// List of query params allowed for take control actions
// Used to prevent malicious query params like redirectTo from being preserved
export const ALLOWED_TAKE_CONTROL_QUERY_PARAMS = ['modal', 'action'];
